import { useQuery } from '@apollo/client';
import { SpinnerIndicators } from '@clearkit/icons';
import { CKLayoutVertical, CKSearch } from 'clearkit';
import { useEffect, useState } from 'react';

import { GridList } from '~/components/unified/GridList';
import { AccountFlagEnum } from '~/generated/graphql';

import FlagItem from './FlagItem';
import query from './query.graphql';

export function FeatureFlags() {
  const { data, loading } = useQuery(query);
  const [search, setSearch] = useState('');
  const [filteredFlags, setFilteredFlags] = useState<AccountFlagEnum[]>([]);

  const handleFilter = (search: string) => {
    setSearch(search);

    if (search) {
      const filteredFlags = data?.availableFeatureFlags.filter(
        (flag: AccountFlagEnum) => flag.includes(search.toLowerCase()),
      );
      setFilteredFlags(filteredFlags);
    } else {
      setFilteredFlags(data?.availableFeatureFlags);
    }
  };

  useEffect(() => {
    if (data?.availableFeatureFlags) {
      setFilteredFlags(data?.availableFeatureFlags);
    }
  }, [data]);

  if (loading) {
    return (
      <CKLayoutVertical
        alignItems="center"
        className="w-full h-full"
        justifyContent="center"
      >
        <SpinnerIndicators className="w-12 h-12" />
      </CKLayoutVertical>
    );
  }

  return (
    <GridList gridGap="1rem" gridTemplateColumns="1fr 16rem">
      <div className="sticky top-0 z-10 bg-gray-50">
        <div className="px-4 py-3">
          <CKSearch
            autoFocus
            className="w-full"
            onChange={handleFilter}
            placeholder="Filter feature flags"
            value={search}
          />
        </div>
        <GridList.Header className="px-4 py-3 border-t border-b border-gray-200 bg-gray-50">
          <div className="sticky left-0">Flag</div>
          <div className="text-right">Flag Setting</div>
        </GridList.Header>
      </div>
      {filteredFlags.length
        ? filteredFlags.map((flag: AccountFlagEnum) => (
            <FlagItem flag={flag} key={flag} />
          ))
        : null}
    </GridList>
  );
}
